// src/Components/FirmwareESP32Uploader.jsx
import React, { useState, useRef } from 'react';
import '../css/FirmwareUpload.css';
import api from '../utils/api'; // ✅ default import

// 필요 시 여기만 바꿔서 백엔드 경로 맞추세요.
const UPLOAD_URL = '/upload';   // 예: '/api/firmware/upload'
const NOTIFY_URL = '/notify';   // 예: '/api/firmware/notify'

export default function FirmwareESP32Uploader({ deviceId, onUpload }) {
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState('선택된 파일 없음');
  const [busy, setBusy] = useState(false);
  const inputRef = useRef(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) {
      alert('❌ 펌웨어 파일을 선택해야 합니다.');
      return;
    }
    // 간단한 확장자/용량 체크 (옵션)
    if (!file.name.toLowerCase().endsWith('.bin')) {
      if (!window.confirm('확장자가 .bin이 아닙니다. 계속 진행할까요?')) return;
    }
    // 예: 20MB 제한
    const MAX_SIZE = 20 * 1024 * 1024;
    if (file.size > MAX_SIZE) {
      alert('❌ 파일이 너무 큽니다. 20MB 이하로 업로드하세요.');
      return;
    }

    setBusy(true);
    try {
      // 1) 펌웨어 업로드
      const formData = new FormData();
      formData.append('file', file);
      // axios는 FormData면 Content-Type을 자동으로 multipart/form-data로 설정합니다.
      const uploadRes = await api.post(UPLOAD_URL, formData);
      console.log('✅ 펌웨어 업로드 성공:', uploadRes.data);

      // 2) 디바이스 알림
      await api.post(NOTIFY_URL, { deviceIds: [deviceId] });
      alert(`✅ ${deviceId}에 알림을 보냈습니다.`);

      // 콜백 & 입력 초기화
      onUpload?.([deviceId]);
      setFile(null);
      setFileName('선택된 파일 없음');
      if (inputRef.current) inputRef.current.value = '';
    } catch (err) {
      console.error('펌웨어 업로드/알림 오류:', err?.response?.status, err?.response?.data || err);
      alert('❌ 업로드 또는 알림 전송에 실패했습니다.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <h2>ESP32 펌웨어 업로드</h2>

      <input
        ref={inputRef}
        type="file"
        hidden
        accept=".bin"
        onChange={(e) => {
          const f = e.target.files?.[0];
          setFile(f || null);
          setFileName(f?.name || '선택된 파일 없음');
        }}
      />

      <button
        type="button"
        className="btn-file-select"
        onClick={() => inputRef.current?.click()}
        disabled={busy}
      >
        📁 펌웨어 선택 (.bin)
      </button>
      <span className="file-name">{fileName}</span>

      <div className="btn-row">
        <button type="submit" className="btn-submit" disabled={busy}>
          {busy ? '업로드 중…' : '업로드'}
        </button>
      </div>
    </form>
  );
}
